<p-toast position="top-right"></p-toast>

<div class="partner-store-handoff-body">
    <partner-mart-locations-delivery-detail *ngIf="showDeliveryDetailSideBar"
                                            [showDeliveryDetailSideBar]="showDeliveryDetailSideBar"
                                            [storeId]="storeId"
                                            [partnerMartLocationsHandoffComponent]="this"
                                            (changedShowDeliveryDetailSideBarEmit)="changedShowDeliveryDetailSideBarEmit($event)"></partner-mart-locations-delivery-detail>

    <!--Body Header-->
    <partner-mart-locations-header [store]="store"></partner-mart-locations-header>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div class="flex flex-row" *ngIf="!loading">
        <div class="psh-column">
            <div class="flex flex-row psh-column-header">
                <div class="psh-column-header__left-block">
                    <div class="psh-column-header-title">Delivery details</div>
                </div>
                <div class="psh-column-header__right-block">
                    <button class="bluedark-btn" pButton label="Edit" (click)="openDeliveryDetailSideBar()"></button>
                </div>
            </div>

            <div>
                <div class="psh-field-label">Street Address</div>
                <div class="psh-field-value">
                    {{storeData.PickupAddress}}
                </div>
            </div>

            <div>
                <div class="psh-field-label">Location Details</div>
                <div class="flex flex-row">
                    <div class="psh-field-column psh-field-value">
                        {{storeData.PickupTitle}}
                    </div>
                    <div class="psh-field-column psh-field-value">
                        {{storeData.LoacationTypeName}}
                    </div>
                </div>
                <div class="psh-field-value">
                    {{storeData.PickupAddressDetail}}
                </div>
            </div>

            <div>
                <div class="psh-field-label">Delivery Location Photo(s) (sent to driver)</div>
                <div class="psh-field-img">
                    <img src="{{storeData.PickupImageUrl}}" />
                </div>
            </div>
        </div>
    </div>
</div>
